import { render, staticRenderFns } from "./av-chosen.vue?vue&type=template&id=439b65e6"
import script from "./av-chosen.vue?vue&type=script&lang=js"
export * from "./av-chosen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports